{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "task_record_schema.json",
  "title": "TaskRecord",
  "description": "Canonical schema for task records as defined in task_protocol.md",
  "additionalProperties": false,
  "type": "object",
  "required": [
    "id",
    "title",
    "status",
    "priority",
    "description"
  ],
  "properties": {
    "id": {
      "type": "string",
      "pattern": "^\\d{10}-task-[a-z0-9-]{1,50}$",
      "maxLength": 66,
      "description": "Unique identifier for the task (10 timestamp + 1 dash + 4 'task' + 1 dash + max 50 slug = 66 max)",
      "examples": [
        "1752274500-task-implementar-auth",
        "1752347700-task-fix-logging"
      ]
    },
    "title": {
      "type": "string",
      "minLength": 3,
      "maxLength": 150,
      "description": "A brief, human-readable title for the task. Used to generate the ID slug."
    },
    "cycleIds": {
      "type": "array",
      "items": {
        "type": "string",
        "minLength": 1,
        "pattern": "^\\d{10}-cycle-[a-z0-9-]{1,50}$",
        "maxLength": 67
      },
      "default": [],
      "description": "Optional. The IDs of the strategic cycles this task belongs to. (10 timestamp + 1 dash + 5 'cycle' + 1 dash + max 50 slug = 67 max)"
    },
    "status": {
      "type": "string",
      "enum": [
        "draft",
        "review",
        "ready",
        "active",
        "done",
        "archived",
        "paused",
        "discarded"
      ],
      "maxLength": 40,
      "description": "Current state of the task in the institutional flow"
    },
    "priority": {
      "type": "string",
      "enum": [
        "low",
        "medium",
        "high",
        "critical"
      ],
      "maxLength": 40,
      "description": "Strategic or tactical priority level"
    },
    "description": {
      "type": "string",
      "minLength": 10,
      "maxLength": 22000,
      "description": "Functional, technical or strategic summary of the objective"
    },
    "tags": {
      "type": "array",
      "items": {
        "type": "string",
        "minLength": 1,
        "pattern": "^[a-z0-9-]+(:[a-z0-9-:]+)*$"
      },
      "default": [],
      "description": "Optional. List of key:value tags for categorization and role suggestion (e.g., 'skill:react', 'role:agent:developer')."
    },
    "references": {
      "type": "array",
      "items": {
        "type": "string",
        "minLength": 1,
        "maxLength": 500
      },
      "default": [],
      "description": "Valid links or files, when mentioned"
    },
    "notes": {
      "type": "string",
      "minLength": 0,
      "maxLength": 3000,
      "description": "Additional comments, decisions made or added context"
    }
  },
  "examples": [
    {
      "id": "1752274500-task-implement-oauth-flow",
      "title": "Implement OAuth 2.0 authentication flow",
      "status": "draft",
      "priority": "high",
      "description": "Implement complete OAuth 2.0 flow with GitHub provider. Include token refresh, session management, and secure storage. Must support both web and CLI flows.",
      "cycleIds": [
        "1752270000-cycle-auth-mvp"
      ],
      "tags": [
        "skill:security",
        "category:feature",
        "package:core"
      ],
      "references": [
        "url:https://docs.github.com/en/apps/oauth-apps/building-oauth-apps"
      ],
      "notes": "Consider using proven library like passport.js or implement from scratch for learning."
    },
    {
      "id": "1752347700-task-fix-memory-leak-indexer",
      "title": "Fix memory leak in indexer process",
      "status": "active",
      "priority": "critical",
      "description": "Indexer process consuming >2GB RAM after 24h uptime. Profiling shows EventEmitter listeners not being cleaned up properly. Fix leak and add monitoring.",
      "cycleIds": [],
      "tags": [
        "category:bug",
        "skill:performance",
        "package:core"
      ],
      "references": [
        "file:packages/core/src/adapters/indexer_adapter/index.ts",
        "commit:a1b2c3d4",
        "issue:789"
      ],
      "notes": "Discovered during production monitoring. Affects long-running processes only."
    },
    {
      "id": "1752448900-task-add-typescript-linting",
      "title": "Add TypeScript strict mode and ESLint rules",
      "status": "done",
      "priority": "medium",
      "description": "Enable TypeScript strict mode across all packages. Configure ESLint with recommended rules. Fix all existing violations. Add pre-commit hook.",
      "cycleIds": [
        "1752440000-cycle-code-quality-q1"
      ],
      "tags": [
        "category:tooling",
        "skill:typescript",
        "epic:code-quality"
      ],
      "references": [
        "pr:123",
        "file:.eslintrc.js",
        "file:tsconfig.json"
      ],
      "notes": "Approved by tech lead. All 47 violations fixed in PR #123."
    },
    {
      "id": "1752550000-task-research-graphql-migration",
      "title": "Research GraphQL migration feasibility",
      "status": "draft",
      "priority": "low",
      "description": "Evaluate feasibility of migrating REST API to GraphQL. Document pros/cons, effort estimation, and recommended approach. Focus on developer experience and performance.",
      "cycleIds": [],
      "tags": [
        "category:research",
        "skill:graphql",
        "skill:backend"
      ],
      "references": []
    }
  ]
}